import { analyticsConsent } from "@/lib/analytics";
import { cleanCampaign, arrivalCampaign } from "@/lib/campaign";
const STORAGE_KEY = "gameplat_attribution";

function storage() {
  try { return window.localStorage; } catch { return null; }
}

export function captureAttribution() {
  if (analyticsConsent() !== "granted") return {};
  const data = arrivalCampaign();
  try { if (Object.keys(data).length) storage()?.setItem(STORAGE_KEY, JSON.stringify(data)); } catch {}
  return Object.keys(data).length ? data : getAttribution();
}

export function getAttribution() {
  if (analyticsConsent() !== "granted") return {};
  try { return cleanCampaign(JSON.parse(storage()?.getItem(STORAGE_KEY) || "{}")); } catch { return {}; }
}

export function trackMarketingEvent(name, params = {}) {
  if (typeof window === "undefined" || !name || analyticsConsent() !== "granted") return;
  const payload = { ...getAttribution(), page_path: window.location.pathname };
  if (typeof window.gtag === "function") window.gtag("event", name, payload);
  window.dispatchEvent(new CustomEvent("gameplat:analytics", { detail: { name, params: payload } }));
}
